import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'

import { FormFieldConfig } from '../../../../features/ui-config'
import i18n from '../../../i18n'

export function createCalculatingComponent(config: FormFieldConfig) {
  return (
    <IconField iconPosition="left">
      <InputIcon className="pi pi-spin pi-spinner"> </InputIcon>
      <InputText
        value={i18n.t('common.values.calculating')}
        disabled={config?.readonly}
        className="w-full"
      />
    </IconField>
  )
}
